import { Popup } from "semantic-ui-react";
import scssVariables from "../../../styles/var-export.module.scss";
import { getIntegrityIcon } from "./DataIntegrityIcons";
import "./DataIntegrityKey.scss";

const KEY_ITEMS = [
	{
		integrityValue: 5,
		label: "Supplied",
		tooltip: "Data supplied directly by the property owner or client",
		pillBackgroundColor: "transparent",
		pillBordered: true,
		iconBackgroundColor: scssVariables.integritySuppliedIconBackground,
		iconBordered: true,
	},
	{
		integrityValue: 4,
		label: "EPC",
		tooltip: "Data imported from EPC Database",
		pillBackgroundColor: scssVariables.integrityEpcPillBackground,
		pillBordered: false,
		iconBackgroundColor: scssVariables.integrityEpcIconBackground,
		iconBordered: false,
	},
	{
		integrityValue: 3,
		label: "Cloned",
		tooltip: "Data cloned from another matching record",
		pillBackgroundColor: scssVariables.integrityClonedPillBackground,
		pillBordered: false,
		iconBackgroundColor: scssVariables.integrityClonedIconBackground,
		iconBordered: false,
	},
	{
		integrityValue: 1,
		label: "Assumed",
		tooltip: "Data assumed based on typical property characteristics",
		pillBackgroundColor: scssVariables.integrityAssumedPillBackground,
		pillBordered: false,
		iconBackgroundColor: scssVariables.integrityAssumedIconBackground,
		iconBordered: false,
	},
	{
		integrityValue: 2,
		label: "Confirmed/XML",
		tooltip: "Data confirmed via XML, API, or direct measurement",
		pillBackgroundColor: scssVariables.integrityConfirmedPillBackground,
		pillBordered: false,
		iconBackgroundColor: scssVariables.integrityConfirmedIconBackground,
		iconBordered: false,
	},
];

export default function DataIntegrityKey() {
	return (
		<div className="data-integrity-key">
			{KEY_ITEMS.map((item) => (
				<div
					key={item.integrityValue}
					className={`key-item${item.pillBordered ? " bordered" : ""}`}
					style={{ backgroundColor: item.pillBackgroundColor }}
				>
					<Popup
						content={item.tooltip}
						position="top center"
						className="integrity-key-popup"
						trigger={
							<div className="key-icon-label">
								<div
									className={`key-icon${item.iconBordered ? " bordered" : ""}`}
									style={{ backgroundColor: item.iconBackgroundColor }}
								>
									{getIntegrityIcon(item.integrityValue)}
								</div>
								<span className="key-label">{item.label}</span>
							</div>
						}
					/>
				</div>
			))}
		</div>
	);
}
